<div class="nav-header" style="display:flex; align-items:center; width:100%;">
  <style>
    .burger-btn {
      display: inline-flex; align-items: center; justify-content: center;
      width: 36px; height: 36px; margin: 6px 8px;
      border-radius: 8px; border: 1px solid #e5e7eb; background: #ffffff;
      cursor: pointer; transition: box-shadow .2s ease, border-color .2s ease;
    }
    .burger-btn:hover { box-shadow: 0 1px 4px rgba(0,0,0,.08); border-color: #d1d5db; }
    .burger-inner { position: relative; width: 18px; height: 14px; transition: transform .25s ease; }
    .burger-inner .bar {
      position: absolute; left: 0; right: 0; height: 2px; background: #6b7280; border-radius: 2px;
      transform-origin: center; transition: transform .25s ease, opacity .2s ease, top .25s ease;
    }
    .burger-inner .bar:nth-child(1) { top: 0; }
    .burger-inner .bar:nth-child(2) { top: 6px; }
    .burger-inner .bar:nth-child(3) { top: 12px; }
    /* When open, rotate the whole group 90deg so the lines quedan verticales */
    .burger-btn.open .burger-inner { transform: rotate(90deg); }
  </style>
  <!-- Left: Real hamburger button -->
  <button type="button" (click)="toggleSidebar()" aria-label="Abrir menú" title="Menú"
          class="burger-btn" [class.open]="isOpen" [attr.aria-expanded]="isOpen">
    <span class="burger-inner">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </span>
  </button>
  <!-- Centro: Nombre del negocio -->
  <div class="nav-center" style="flex:1; text-align:center; font-weight:600; color:#374151;">
    {{ businessName || 'Sin negocio' }}
  </div>

  <div class="nav-actions" style="margin-left:auto; display:flex; align-items:center; gap:10px;">
    <span class="user-badge" title="{{ userName }}" style="display:inline-flex; align-items:center; justify-content:center; width:28px; height:28px; border-radius:9999px; background:#f97316; color:#fff; font-weight:700; font-size:12px; text-transform:uppercase; box-shadow:0 1px 3px rgba(0,0,0,.1);">{{ initials || '?' }}</span>
    <button type="button" class="logout-btn" (click)="logout()" aria-label="Salir">
      <!-- simple icon -->
      <span class="icon">⎋</span>
      <span class="label">Salir</span>
    </button>
  </div>
</div>
